<template>
  <p v-if="error" class="rf-estado rf-estado--error">{{ error }}</p>
  <div v-else-if="p" class="rf-ficha">
    <div class="rf-ficha-foto">
      <img v-if="p.foto" :src="p.foto" :alt="p.nombre">
    </div>

    <div class="rf-ficha-datos">
      <h1>{{ p.nombre }}</h1>
      <p class="rf-frase">{{ p.descripcion }}</p>
      <div class="rf-ficha-caja">
        <p v-if="p.subtitulo" class="rf-subtitulo">{{ p.subtitulo }}</p>
        <div class="rf-campos">
          <div
            v-for="c in campos"
            :key="c.etiqueta"
            class="rf-campo"
            :class="{ 'rf-campo--ancho': c.ancho }"
          >
            <p class="rf-meta-label">{{ c.etiqueta }}</p>
            <div>{{ c.valor }}</div>
          </div>
        </div>
        <a :href="`/landing-refugios/${p.id}/mapa`" class="rf-btn">Más información</a>
      </div>
    </div>
  </div>
</template>

<script>
import { dolares, entero, hectareas, porcentaje } from './formato';
import { obtenerProyecto } from '@/services/refugiosApi';

export default {
  name: 'RfFicha',
  props: {
    proyecto: { type: Number, required: true },
  },
  data() {
    return { p: null, error: '' };
  },
  computed: {
    campos() {
      const p = this.p;
      return [
        { etiqueta: 'Ubicación', valor: p.ubicacion, ancho: true },
        { etiqueta: 'Proyecto', valor: hectareas(p.hectareas) },
        { etiqueta: 'N° propietarios', valor: entero(p.propietarios) },
        { etiqueta: 'Área protegida', valor: porcentaje(p.area_protegida) },
        { etiqueta: 'Área habitable', valor: porcentaje(p.area_habitable) },
        { etiqueta: 'Precio desde', valor: dolares(p.precio_desde), ancho: true },
      ];
    },
  },
  async mounted() {
    try {
      this.p = await obtenerProyecto(this.proyecto);
    } catch (e) {
      this.error = 'No se pudo cargar el proyecto. Intenta de nuevo en un momento.';
    }
  },
};
</script>
